import { connect } from 'react-redux';
import ReviewsAgg from 'marketing/components/reviews_agg';

const mapStateToProps = ({ marketing }) => {
  return {
    stats: marketing.reviewStats
  };
}

export default connect(mapStateToProps)(ReviewsAgg);
